import { Box, Button, Stack } from '@chakra-ui/react'
import { createFileRoute, getRouteApi, Link } from '@tanstack/react-router'
import { FaArrowLeft } from 'react-icons/fa6'
import { Route as encodingPresetsListRoute } from '@routes/_auth/o/$orgId/encodingPresets'
import { CreateEncodingPresetForm } from '@features/encodingPreset/components/CreateEncodingPresetForm'

const routeApi = getRouteApi('/_auth/o/$orgId/encodingPresets/new')

const BackButton = () => {
  const { orgId } = routeApi.useParams()
  return (
    <Box>
      <Link to={encodingPresetsListRoute.to} params={{ orgId }}>
        <Button leftIcon={<FaArrowLeft />} size="xs">
          Back to Encoding Presets
        </Button>
      </Link>
    </Box>
  )
}

const CreateEncodingPresetRoute = () => (
  <Stack spacing={4}>
    <BackButton />
    <CreateEncodingPresetForm />
  </Stack>
)

export const Route = createFileRoute('/_auth/o/$orgId/encodingPresets/new')({
  component: CreateEncodingPresetRoute,
  beforeLoad: () => ({ getTitle: () => 'Create Encoding Preset' }),
  loader: () => ({
    crumb: 'New',
  }),
})
